import React from 'react';
import lstyle from '../Styles/Loading.css'
function Loading() {
  return (
    <div className="loading">
      <div className="spinner">
      </div>
    </div>
  );
}

export default Loading;